<p-action-button
    iconBeforeName="plus"
    iconBeforeSize="sm"
    buttonType="button"
    automation-id="ai-chat-attach-menu-trigger"
    [disabled]="disabled()"
    [tooltip]="'aichat.attach.add' | translate"
    [matMenuTriggerFor]="menu"
></p-action-button>
<mat-menu #menu="matMenu" yPosition="above">
    <div class="sources-menu">
        @for (item of items(); track item.source.resourceType) { @if (item.dividerBefore) {
        <mat-divider class="sources-menu-divider"></mat-divider>
        }
        <button
            mat-menu-item
            type="button"
            [attr.automation-id]="'ai-chat-attach-source-' + item.source.resourceType"
            (click)="sourceSelected.emit(item.source)"
        >
            <p-icon class="sources-menu-icon" [name]="item.source.icon" size="sm"></p-icon>
            <span>{{ item.source.labelKey | translate }}</span>
        </button>
        }
    </div>
</mat-menu>
